import {Component, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChange} from '@angular/core';

import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'itpx-multi-dropdown',
    templateUrl: './multi-dropdown.component.html',
    styleUrls: [ './multi-dropdown.component.css' ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MultiDropdownComponent),
            multi: true
        }
    ]
})
export class MultiDropdownComponent implements ControlValueAccessor, OnChanges {

    @Input() options: Array<any>;
    @Input() placeholder: string;
    @Input('value') _value: any;
    @Input() maxSelected: number;
    @Input() showItemIndex: boolean;
    @Input() clearOptions: boolean = false;
    @Input() readOnly: boolean;
    @Output() multiChange: EventEmitter<any> = new EventEmitter();
    propagateChange = (_: any) => {};
    optionsLookup = {};

    private items: Array<string> = [];
    private disabled: boolean = false;

    ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
        if(changes['options']) {
            this.lookup();
        }
        if (changes['clearOptions'] && this.clearOptions) {
            this.items = [];
        }

        if (this.readOnly)
            this.disabled = this.readOnly
    }

    get value() {
        return this._value;
    }

    set value(val) {
        this.items = val;
        this.propagateChange(val);
    }

    writeValue(value) {
        if (value) {
            this.items = value;
        }
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}

    private onSelect(event: any) {
        let item = event.target.value;
        if (!item) return;
        let index = this.items.indexOf(item, 0);
        if (index === -1) this.items.push(item);
        event.target.value = '';
        this.value = this.items;

        if(this.maxSelected && (this.items.length === this.maxSelected)) {
            this.disabled = true;
        } else {
            this.disabled = false;
        }
        this.multiChange.emit(this.items);

    }

    private onRemove(item: string) {
        if (this.readOnly)
            return false;
        let index = this.items.indexOf(item, 0);
        if (index > -1) this.items.splice(index, 1);
        this.value = this.items;

        if(this.maxSelected && (this.items.length < this.maxSelected)) {
            this.disabled = false;
        }

        this.multiChange.emit(this.items);
    }

    private lookup() {
        this.optionsLookup = this.options.reduce(function(o, el, i) {
            o[el.key] = el.value;
            return o;
        }, {});
        return this.optionsLookup;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/multi-dropdown/multi-dropdown.component.ts